import API from "../../helpers/API";
import {
    SHOW_LOADER,
    HIDE_LOADER,
    SET_ALL_UNAPPROVAL_ENTITY_LIST,
    SET_UNAPPROVAL_PAGE_NO_COUNTER,
    SET_PHYSICAL_TEST_DATA,
    SET_MEDICAL_TEST_DATA
} from "../../common/constants/ActionTypes";
import {
    ENTITYAPPROVALACTION,
    ENTITY_APPROVAL,
    UPLOAD_PHYSICAL_TEST_MARKS,
    GET_PHYSICAL_TEST_MARKS,
    PHYSICAL_TEST_MARKS_APPROVAL,
    UPLOAD_MEDICAL_TEST_MARKS,
    GET_MEDICAL_TEST_MARKS,
    MEDICAL_TEST_MARKS_APPROVAL
} from "../../common/constants/endpoints";
import label from "../../common/labels/common_en.json";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";
import FileDownload from "js-file-download";

export const getPhysicalTestMarks = (examId) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${GET_PHYSICAL_TEST_MARKS}/${examId}`,

                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response) {
                dispatch({
                    type: SET_PHYSICAL_TEST_DATA,
                    payload: response.data,
                })
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const getMedicalTestMarks = (examId) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${GET_MEDICAL_TEST_MARKS}/${examId}`,

                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response) {
                dispatch({
                    type: SET_MEDICAL_TEST_DATA,
                    payload: response.data,
                })
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch(hideLoader());
            handleError(error);
        }
    };
};

export const physicalTestMarksApprovalRequest = (examId, updatedValues) => {
    return async (dispatch) => {
        let response;
        try {
            const session = JSON.parse(sessionStorage.getItem("session"));
            let token = session.jwtResponse && session.jwtResponse.token;

            response = await API.post(`${PHYSICAL_TEST_MARKS_APPROVAL}/${examId}`, updatedValues, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage =
                response && response.data ? response.data.message : response.message;
            toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};

export const medicalTestMarksApprovalRequest = (examId, updatedValues) => {
    return async (dispatch) => {
        let response;
        try {
            const session = JSON.parse(sessionStorage.getItem("session"));
            let token = session.jwtResponse && session.jwtResponse.token;

            response = await API.post(`${MEDICAL_TEST_MARKS_APPROVAL}/${examId}`, updatedValues, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage =
                response && response.data ? response.data.message : response.message;
            toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    }
}

export const getAllApprovalPhysicalTestMarksPagination = (
    pageNumber,
    rowPerPage
) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=physicalTest`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            let allDone = false;
            if (response) {

                if (response.data.approvalEmpty === true) {
                    dispatch({
                        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                        payload: {},
                    });
                }

                response &&
                    response.data &&
                    response.data.entityApprovalDtoList &&
                    response.data.entityApprovalDtoList.map((item, index) => {
                        let details =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.entityApprovalDto &&
                            item.entityApprovalAction.entityApprovalDto.detail &&
                            JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
                        let parentdetails =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.parentDetails &&
                            JSON.parse(item.entityApprovalAction.parentDetails);
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.entityApprovalDto.detail = details;
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.parentdetails = parentdetails;
                        if (index == response.data.entityApprovalDtoList.length - 1) {
                            allDone = true;
                        }
                        if (allDone) {
                            dispatch({
                                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                                payload: response.data,
                            });
                            dispatch({
                                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                                payload: pageNumber * rowPerPage,
                            });
                        }
                    });
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: {},
            });
            handleError(error);
        }
    };
};

export const getAllApprovalMedicalTestMarksPagination = (
    pageNumber,
    rowPerPage
) => {
    return async function (dispatch) {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(
                `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=medicalTest`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            let allDone = false;
            if (response) {

                if (response.data.approvalEmpty === true) {
                    dispatch({
                        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                        payload: {},
                    });
                }

                response &&
                    response.data &&
                    response.data.entityApprovalDtoList &&
                    response.data.entityApprovalDtoList.map((item, index) => {
                        let details =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.entityApprovalDto &&
                            item.entityApprovalAction.entityApprovalDto.detail &&
                            JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
                        let parentdetails =
                            item.entityApprovalAction &&
                            item.entityApprovalAction.parentDetails &&
                            JSON.parse(item.entityApprovalAction.parentDetails);
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.entityApprovalDto.detail = details;
                        response.data.entityApprovalDtoList[
                            index
                        ].entityApprovalAction.parentdetails = parentdetails;
                        if (index == response.data.entityApprovalDtoList.length - 1) {
                            allDone = true;
                        }
                        if (allDone) {
                            dispatch({
                                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                                payload: response.data,
                            });
                            dispatch({
                                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                                payload: pageNumber * rowPerPage,
                            });
                        }
                    });
                handleResponseMessage(response);
            }
        } catch (error) {
            dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: {},
            });
            handleError(error);
        }
    };
};

export const approvalPhysicalTestMarksEntityRequest = (requestData, setShowModal) => {
    return async (dispatch) => {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalPhysicalTestMarksPagination(0, 10));

            if (response) {
                handleResponseMessage(response);
            }
            // let successMessage =
            //     response && response.data ? response.data.message : response.message;
            // toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};

export const approvalMedicalTestMarksEntityRequest = (requestData, setShowModal) => {
    return async (dispatch) => {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ENTITY_APPROVAL, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setShowModal(false);
            dispatch(getAllApprovalMedicalTestMarksPagination(0, 10));

            if (response) {
                handleResponseMessage(response);
            }
            // let successMessage =
            //     response && response.data ? response.data.message : response.message;
            // toastr.success(successMessage);
        } catch (error) {
            handleError(error);
        }
    };
};

export const showLoader = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOADER,
        });
    };
};

export const hideLoader = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOADER,
        });
    };
};

export const uploadPhysicalTestMarks = (
    data,
    examId,
    cancelModal,
    resetData,
    minMarks,
    setUploadState
) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let formData = new FormData();
    if (data.file) {
        formData.append("file", data.file);
        formData.append("type", "physicalTest");
    }
    let response;
    let header = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        type: "formData",
    };

    return async (dispatch) => {
        try {
            response = await API.post(
                `${UPLOAD_PHYSICAL_TEST_MARKS}/${examId}/${minMarks}`,
                formData,
                {
                    headers: header,
                }
            );
            if (response) {
                if (response.data !== "") {
                    const lines = response.data.split('\n');
                    const count = parseInt(lines[0].split(':')[1].trim());

                    let successMessage;

                    if (lines.length > 3) {
                        successMessage = count === 0
                            ? 'No records added.'
                            : `${count} records have been added successfully.`;

                        const errorCsvContent = lines.slice(3).join('\n');
                        FileDownload(errorCsvContent, `Data_physicalTest.csv`);
                    } else {
                        successMessage = count === 0
                            ? 'No records added.'
                            : `${count} records have been added successfully.`;
                    }

                    if (count === 0) {
                        toastr.warning(successMessage);
                    } else {
                        toastr.success(successMessage);
                    }
                }
                cancelModal();
                resetData();
            }
        } catch (error) {
            handleError(error);
            setUploadState(false);
        }
    };
};

export const uploadMedicalTestMarks = (
    data,
    examId,
    cancelModal,
    resetData
) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let formData = new FormData();
    if (data.file) {
        formData.append("file", data.file);
        formData.append("type", "medicalTest");
    }
    let response;
    let header = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        type: "formData",
    };

    return async (dispatch) => {
        try {
            response = await API.post(
                `${UPLOAD_MEDICAL_TEST_MARKS}/${examId}`,
                formData,
                {
                    headers: header,
                }
            );

            if (response) {
                if (response.data !== "") {
                    const lines = response.data.split('\n');
                    const count = parseInt(lines[0].split(':')[1].trim());

                    let successMessage;

                    if (lines.length > 3) {
                        successMessage = count === 0
                            ? 'No records added.'
                            : `${count} records have been added successfully.`;

                        const errorCsvContent = lines.slice(3).join('\n');
                        FileDownload(errorCsvContent, `Data_medicalTest.csv`);
                    } else {
                        successMessage = count === 0
                            ? 'No records added.'
                            : `${count} records have been added successfully.`;
                    }

                    if (count === 0) {
                        toastr.warning(successMessage);
                    } else {
                        toastr.success(successMessage);
                    }
                }
                cancelModal();
                resetData();
            }

        } catch (error) {
            handleError(error);
        }
    };
};